<template>
    <div class="bundle-purchase-component bundle-purchase-layout-2 with-flexible-parts flex-wrap align-items-center" @click="enrollButtonClicked">
        <div class="flexible-part">
            <p class="learnworlds-main-text-large">
                <strong>{{ subscriptionPriceLabel }}</strong>
            </p>
        </div>
        <div class="flexible-part">
            <button class="learnworlds-button learnworlds-element js-same-content-child learnworlds-button-large learnworlds-button-solid-accent1"
                    @click="emitAction('subscription-clicked', subscription)">
                {{ $t('subscriptions.buy') }}
            </button>
        </div>
    </div>
</template>

<script>
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "SubscriptionLayout2",
        mixins: [ComponentTemplatesMixin],
        props: {
            subscription : {
                type: Object,
            }
        },
        computed: {
            subscriptionPriceLabel () {
                if (!this.subscription.id) {
                    return "";
                }

                let intervalLabel = "";
                let intervalTypeLabel = this.subscription.interval_type;

                if (this.subscription.interval > 1 ) {
                    intervalLabel = this.subscription.interval;
                    intervalTypeLabel += "s";
                }


                return `${this.subscription.currency}${this.subscription.price}/${intervalLabel}${intervalTypeLabel}`;
            }
        },
        methods: {
            enrollButtonClicked () {
                this.emitAction('subscription-clicked',this.subscription);
            },
        }
    }
</script>

